module.exports = __webpack_public_path__ + "static/media/GPG601A_F01_ZG.3e817098.jpg";